import { createFileRoute } from "@tanstack/solid-router";
import { lazy } from "solid-js";

import { App } from "@/components/base/app";
import { HOME_PERSPECTIVE_SLUG } from "@/scripts/const";

const LoaderPerspective = lazy(async () => {
	const mod = await import("@/components/base/loader-perspective");
	return { default: mod.LoaderPerspective };
});

const Route = createFileRoute("/")({
	ssr: false,
	component: () => (
		<App>
			<LoaderPerspective slug={HOME_PERSPECTIVE_SLUG} />
		</App>
	),
});

export { Route };
